$( function() {
	$( '#test-form, #custom-contact-form' ).find( 'input, textarea, button' ).each( function() {
		var $this = $( this );

		function removeValidationMessage() {
			$this.parent().find( '.form-validation-message' ).remove();
		}

		$this.change( removeValidationMessage );
		$this.keyup( removeValidationMessage );
	} );
	$( '#test-form' ).submit( function( event ) {
		event.preventDefault();

		var $form = $( this );
		var $submit = $form.find( 'button[type="submit"]' );
		$form.find( '.form-validation-message' ).remove();

		$submit.attr( 'disabled', 'disabled' );
		$submit.parent().addClass( 'flex flex-col' );
		$submit.after( '<span class="form-validation-message form-validation-info-message">' + settings.translation.sendingMail + '</span>' );
		let data = new FormData( this );
		fetch( settings.siteAddress + '/helpers/contact/contact.php', {
			method: 'post',
			body: new URLSearchParams( data ).toString(),
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
			},
			cache: 'no-store',
			credentials: 'include'
		} ).then( function( response ) {
			$form.find( '.form-validation-message' ).remove();
			return response.text()
		} ).then( function( response ) {
			response = JSON.parse( response );

			if ( response.result === 'error' ) {
				console.error( 'Server response', response );
				if ( response.message ) {
					$submit.after( '<span class="form-validation-message form-validation-error-message">' + response.message + '</span>' );
				}
				if ( response.fields ) {
					for ( const [field, message] of Object.entries( response.fields ) ) {
						let $field = $( '#test-form' ).find( '#' + field );
						if ( !$field.length ) {
							$field = $( '#test-form' ).find( 'label[for=' + field.replace( /\./g, '_' ) + ']' );
						}
						$field.first().after( '<span class="form-validation-message form-validation-error-message">' + message + '</span>' );
					}
				}

				return;
			}

			$( '#test-form' ).find( 'input, textarea' )
				.not( '[type=checkbox], :button, :submit, :reset, :hidden' )
				.attr( 'value', '' )
				.val( '' );
			$( '#test-form input[type=checkbox]' ).prop( 'checked', false );

			$submit.after( '<span class="form-validation-message form-validation-success-message">' + settings.translation.mailSent + '</span>' );
			setTimeout( function() {
				$form.find( '.form-validation-message' ).remove();
			}, 5000 );

		} ).catch( function( error ) {
			console.error( error );
			$submit.after( '<span class="form-validation-message form-validation-error-message">' + settings.translation.genericError + '</span>' );
		} ).finally( function() {
			$submit.removeAttr( 'disabled' );
		} )
		return false;
	} );

  $( '#custom-contact-form' ).submit( function( event ) {
    event.preventDefault();

    var $form = $( this );
    var $submit = $form.find( 'button[type="submit"]' );
    $form.find( '.form-validation-message' ).remove();

    let atLeastOneLocationChecked = true
    $form.find( '.your-location-checkbox-group' ).each( function() {
      const $checkboxGroup = $( this );
      const $checkboxes = $checkboxGroup.find( 'input[name="your-location[]"]' );
      atLeastOneLocationChecked = ![...$checkboxes].every( ( checkbox ) => !$( checkbox ).is( ':checked' ) );
      if ( !atLeastOneLocationChecked ) {
        $checkboxGroup.first().after( '<span class="form-validation-message form-validation-error-message">' + settings.translation.checkboxRequired + '</span>' );
      }
    } )
    if ( !atLeastOneLocationChecked ) {
      return;
    }

    $submit.attr( 'disabled', 'disabled' );
    $submit.parent().addClass( 'flex flex-col' );
    $submit.after( '<span class="form-validation-message form-validation-info-message">' + settings.translation.sendingMail + '</span>' );
    let data = new FormData( this );
    fetch( settings.siteAddress + '/helpers/contact/custom-contact.php', {
      method: 'post',
      body: new URLSearchParams( data ).toString(),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      cache: 'no-store',
      credentials: 'include'
    } ).then( function( response ) {
      $form.find( '.form-validation-message' ).remove();
      return response.text()
    } ).then( function( response ) {
      response = JSON.parse( response );

      if ( response.result === 'error' ) {
        console.error( 'Server response', response );
        if ( response.message ) {
          $submit.after( '<span class="form-validation-message form-validation-error-message">' + response.message + '</span>' );
        }
        if ( response.fields ) {
          for ( const [field, message] of Object.entries( response.fields ) ) {
            let $field = $( '#custom-contact-form' ).find( '#' + field );
            if ( field === 'your-location.0' ) {
              $field = $form.find( '.your-location-checkbox-group' );
            } else if ( field.startsWith( 'your-location' ) ) {
              continue;
            } else if ( !$field.length ) {
              $field = $( '#custom-contact-form' ).find( 'label[for=' + field.replace( /\./g, '_' ) + ']' );
            }
            $field.first().after( '<span class="form-validation-message form-validation-error-message">' + message + '</span>' );
          }
        }

        return;
      }

      $( '#custom-contact-form' ).find( 'input, textarea' )
        .not( '[type=checkbox], :button, :submit, :reset, :hidden' )
        .attr( 'value', '' )
        .val( '' );
      $( '#custom-contact-form input[type=checkbox]' ).prop( 'checked', false );

      $submit.after( '<span class="form-validation-message form-validation-success-message">' + settings.translation.mailSent + '</span>' );
      setTimeout( function() {
        $form.find( '.form-validation-message' ).remove();
      }, 5000 );

    } ).catch( function( error ) {
      console.error( error );
      $submit.after( '<span class="form-validation-message form-validation-error-message">' + settings.translation.genericError + '</span>' );
    } ).finally( function() {
      $submit.removeAttr( 'disabled' );
    } )
    return false;
  } );
} );
